import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatDate } from '../utils/formatters';

// Funzione per esportare in Excel (CSV)
export const exportToExcel = (viaggi, contatti, magazzini, fileName = 'report-viaggi') => {
  // Preparazione dati
  let csvContent = "data:text/csv;charset=utf-8,";
  csvContent += "Data,Cliente,Vettore,Prezzo Cliente,Prezzo Vettore,PLT,Magazzino Carico,Magazzino Scarico\n";
  
  viaggi.forEach(viaggio => {
    const cliente = contatti.find(c => c.id === viaggio.clienteId) || {};
    const vettore = contatti.find(v => v.id === viaggio.vettoreId) || {};
    const magCarico = magazzini.find(m => m.id === viaggio.magazzinoCarico) || {};
    const magScarico = magazzini.find(m => m.id === viaggio.magazzinoScarico) || {};
    
    // Funzione per escapare correttamente i valori CSV
    // Se contiene virgole, virgolette o nuove linee, racchiudi tra virgolette e raddoppia le virgolette interne
    const escapeCSV = (value) => {
      if (!value) return '';
      const stringValue = String(value);
      // Se contiene virgole, virgolette o nuove linee, dobbiamo escaparlo
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        // Sostituisci eventuali virgolette con doppie virgolette e racchiudi tra virgolette
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    };
    
    // Prepara ciascun valore per il CSV
    const clienteVal = escapeCSV(`${cliente.azienda || ''} (${cliente.nome || ''} ${cliente.cognome || ''})`);
    const vettoreVal = escapeCSV(`${vettore.azienda || ''} (${vettore.nome || ''} ${vettore.cognome || ''})`);
    const magCaricoVal = escapeCSV(magCarico.nome || '');
    const magScaricoVal = escapeCSV(magScarico.nome || '');
    
    const row = [
      formatDate(viaggio.data),
      clienteVal,
      vettoreVal,
      viaggio.prezzoCliente || '0',
      viaggio.prezzoVettore || '0',
      viaggio.bancali || '0',
      magCaricoVal,
      magScaricoVal
    ];
    
    csvContent += row.join(",") + "\n";
  });
  
  // Creazione del link di download
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${fileName}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Funzione per esportare in PDF
export const exportToPDF = (viaggi, contatti, magazzini, fileName = 'report-viaggi') => {
  // Modificato per orientamento orizzontale (landscape) con margini minimi
  const doc = new jsPDF({
    orientation: 'landscape', // Orientamento orizzontale
    unit: 'mm',
    format: 'a4',
    margins: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    }
  });
  
  // Aggiunta titolo - adattato per layout orizzontale con margini ridotti
  doc.setFontSize(18);
  doc.text('Report Viaggi', 7, 10);
  
  // Data report
  doc.setFontSize(11);
  doc.text(`Generato il: ${formatDate(new Date().toISOString())}`, 7, 18);
  
  // Preparazione dati per la tabella
  const tableData = viaggi.map(viaggio => {
    const cliente = contatti.find(c => c.id === viaggio.clienteId) || {};
    const vettore = contatti.find(v => v.id === viaggio.vettoreId) || {};
    const magCarico = magazzini.find(m => m.id === viaggio.magazzinoCarico) || {};
    const magScarico = magazzini.find(m => m.id === viaggio.magazzinoScarico) || {};
    
    return [
      formatDate(viaggio.data),
      `${cliente.azienda || ''} (${cliente.nome || ''} ${cliente.cognome || ''})`,
      `${vettore.azienda || ''} (${vettore.nome || ''} ${vettore.cognome || ''})`,
      `€ ${viaggio.prezzoCliente || '0'}`,
      `€ ${viaggio.prezzoVettore || '0'}`,
      viaggio.bancali || '0',
      magCarico.nome || '',
      magScarico.nome || ''
    ];
  });
  
  // Calcolo totali
  const totalPrezzoCliente = viaggi.reduce((sum, viaggio) => sum + Number(viaggio.prezzoCliente || 0), 0).toFixed(2);
  const totalPrezzoVettore = viaggi.reduce((sum, viaggio) => sum + Number(viaggio.prezzoVettore || 0), 0).toFixed(2);
  const totalBancali = viaggi.reduce((sum, viaggio) => sum + Number(viaggio.bancali || 0), 0);
  
  // Aggiunta riga di totale
  tableData.push([
    '', 'TOTALE', '', `€ ${totalPrezzoCliente}`, `€ ${totalPrezzoVettore}`, totalBancali, '', ''
  ]);
  
  // Generazione tabella - adattata per il formato orizzontale con margini ridotti
  doc.autoTable({
    startY: 22,
    head: [['Data', 'Cliente', 'Vettore', 'Prezzo Cliente', 'Prezzo Vettore', 'PLT', 'Carico', 'Scarico']],
    body: tableData,
    theme: 'striped',
    headStyles: { fillColor: [66, 139, 202] },
    footStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' },
    margin: { top: 22, left: 5, right: 5, bottom: 5 },
    // Larghezze colonne ottimizzate per orientamento orizzontale
    columnStyles: {
      0: { cellWidth: 23 },     // Data 
      1: { cellWidth: 62 },     // Cliente (allargata)
      2: { cellWidth: 62 },     // Vettore (allargata)
      3: { cellWidth: 25 },     // Prezzo Cliente
      4: { cellWidth: 25 },     // Prezzo Vettore
      5: { cellWidth: 15 },     // PLT
      6: { cellWidth: 37 },     // Carico (ridotta)
      7: { cellWidth: 37 }      // Scarico (ridotta)
    },
    // Opzioni per evitare il ritorno a capo delle celle
    bodyStyles: { 
      overflow: 'ellipsize', 
      cellWidth: 'wrap' 
    }
  });
  
  // Salvataggio PDF
  doc.save(`${fileName}.pdf`);
};